/** Compatibility shim — implementation moved; import from the new path. */
export * from '../shared/lib/httpClient';
export { default } from '../shared/lib/httpClient';
